import React from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import AdmissionHeader from './Components/AdmissionHeader'
import {AdmissionBody} from './Components/AdmissionBody'
import AddAdmission from './Components/AddAdmission'
import ViewApplicants from './Components/ViewApplicants'
const admission: Array<PageLink> = [
  {
    title: 'Fess',
    path: '/Admission/fess',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export default function Admission() {
  return (
    <div>
      <Routes>
        <Route
          element={
            <>
              <AdmissionHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='admissionHome'
            element={
              <>
                <PageTitle breadcrumbs={admission}>Admission Home</PageTitle>
                <AdmissionBody />
              </>
            }
          />
          <Route
            path='ViewApplicants'
            element={
              <>
                <PageTitle breadcrumbs={admission}>View Applicants</PageTitle>
                <ViewApplicants />
              </>
            }
          />

          <Route index element={<Navigate to='/Admission/admissionHome' />} />
        </Route>

        <Route path='Add' element={<AddAdmission />} />
      </Routes>
    </div>
  )
}
